import React from "react";
import { arrowRight } from "../../../assets/logos/icons";
import { Link } from "react-router-dom";
import "./arrowBtnHL.css";

const ArrowBtnHLPure = (props) => {
  const { textArrowBtn, onClickArrowBtn, primary, disabled } = props;

  return (
    <button
      disabled={disabled}
      className={
        primary === true
          ? "arrowBtnHLPure-primary-btn"
          : "arrowBtnHLPure-secondary-btn"
      }
      onClick={onClickArrowBtn}
    >
      {textArrowBtn}
      {/* <img src={arrowRight} className="arrowBtnHLPure-arrow" /> */}
      <span className="arrowBtnHLPure-arrow">{">"}</span>
    </button>
  );
};

export { ArrowBtnHLPure as default };
